import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'

export default function ObservacaoSection({ observacao, onChange }) {
  return (
    <>
      <Row className="mt-3 pt-2">
        <Col>
          <h2 className="paciente-form-section-title mb-0">Observação</h2>
        </Col>
      </Row>
      <Row className="form-row">
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Observação</Form.Label>
            <Form.Control as="textarea" rows={3} name="observacao" value={observacao} onChange={onChange} />
          </Form.Group>
        </Col>
      </Row>
    </>
  )
}
